import { useEffect } from "react";

export const useClickOutsideSearch = ({ searchRef, keyRef, setSearchInFocus }) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target) &&
        !event.target.closest(`#${keyRef.current}`)
      ) {
        setSearchInFocus(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside, false);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, false);
    };
  }, [keyRef, searchRef, setSearchInFocus]);
};
